var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.named ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Character')
    }
  })], 1) : _c('div', [_vm.character ? _c('div', {
    key: "original-character-icon-".concat(_vm.id),
    staticClass: "float-right px-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.originalcharactericon.format(_vm.character.m_ID) + '.png',
      "target": "_blank"
    }
  }, [_c('CharaIcon', {
    attrs: {
      "original": "",
      "id": _vm.character.m_ID,
      "size": _vm.$size(64)
    }
  })], 1)]) : _vm._e(), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.named.fullName, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.named.fullName))])]), _vm.character ? _c('div', {
    staticClass: "px-4 mb-4"
  }, [_c('p', {
    class: {
      small: _vm.$vuetify.breakpoint.xsOnly
    },
    domProps: {
      "innerHTML": _vm._s(_vm.character.m_Descript.replace(/\n/g, '<br>'))
    }
  })]) : _vm._e(), _c('Scroller', {
    attrs: {
      "icon": _vm.$size(64)
    }
  }, [_vm._l(_vm.characters, function (character) {
    return _c('div', {
      key: "named-characters-".concat(character.m_CharaID),
      staticClass: "ml-4",
      style: {
        width: _vm.$size(64) + 'px'
      }
    }, [_c('router-link', {
      attrs: {
        "to": "/character/".concat(character.m_CharaID)
      }
    }, [_c('CharaIcon', {
      attrs: {
        "id": character.m_CharaID,
        "size": _vm.$size(64)
      }
    }), _c('div', {
      staticClass: "caption text-center two-lines"
    }, [_vm._v(_vm._s(_vm.$name(character.m_Name)))])], 1)], 1);
  }), _c('div', {
    staticClass: "pl-4"
  })], 2), _c('v-list-item', {
    attrs: {
      "to": "/standpic/".concat(_vm.named.m_ResouceBaseName.replace(/^Kirara_/, ''))
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Standpic')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki.character.format(_vm.named.m_FullName)
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.named.m_FullName) + " - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1), _c('v-divider'), _c('Ad', {
    key: "named-ad-".concat(_vm.id)
  }), _c('Profile', {
    attrs: {
      "id": _vm.id
    }
  }), _c('Voices', {
    attrs: {
      "id": _vm.id,
      "characterList": _vm.characters
    }
  }), _c('Talent', {
    attrs: {
      "id": _vm.id
    }
  }), _c('Scenarios', {
    attrs: {
      "id": _vm.id
    }
  }), _c('RoomObject', {
    attrs: {
      "id": _vm.id
    }
  }), _c('v-divider'), _c('Ad', {
    key: "named-ad-".concat(_vm.id, "-1")
  }), _c('Related', {
    attrs: {
      "id": _vm.id
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }